import { useCallback, useMemo, useState } from 'react'
import { css } from '@emotion/react'
import {
  type IPickerListItem,
  Picker,
  Text,
} from '@livechat/design-system-react-components'

const sortFieldCss = css`
  min-width: 200px;
`

const prepareValues = (values: SortOptions[]): IPickerListItem[] =>
  values.map(({ LABEL, VALUE }) => ({
    key: VALUE,
    name: LABEL,
    customElement: {
      listItemBody: (
        <Text as="span" data-test={VALUE}>
          {LABEL}
        </Text>
      ),
    },
  }))

interface SortOptions {
  LABEL: string
  VALUE: string
}

interface Props {
  options: SortOptions[]
  onSortChange: (value: string) => void
  value: string
}

const getInitialValue = (options: SortOptions[], value: string) => {
  const item = options.find((option) => option.VALUE === value)
  return item ? prepareValues([item]) : null
}

const Sort = ({ options, onSortChange, value }: Props) => {
  const [selectedValue, setSelectedValue] = useState<IPickerListItem[] | null>(
    () => getInitialValue(options, value)
  )

  const handleSelect = useCallback(
    (value: IPickerListItem[] | null) => {
      setSelectedValue(value)
      if (value) {
        onSortChange(value[0].key)
      }
    },
    [onSortChange]
  )

  const items = useMemo(() => prepareValues(options), [options])

  return (
    <Picker
      css={sortFieldCss}
      data-testid="picker-head-item"
      options={items}
      onSelect={handleSelect}
      selected={selectedValue}
      searchDisabled
      isRequired
    />
  )
}

export default Sort
